import {put, takeLatest, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {get} from 'lodash';
import {PHONE_DIAL_CODE} from '@app/utils/constants';
import {
  sendInviteRequest,
  sendInviteSuccess,
  sendInviteError,
  fetchInvitesRequest,
  fetchInvitesSuccess,
  fetchInvitesError,
} from './index';
import {sendInvite, sendInviteLink, fetchInvites} from './api';

export const sagaActions = {
  SEND_INVITE: 'SEND_INVITE',
  FETCH_INVITES: 'FETCH_INVITES',
};

function* sendInviteSaga({payload}) {
  const {values} = payload;
  try {
    yield put(sendInviteRequest());
    const result = yield call(sendInvite, {
      ...values,
      executivePhone: `${PHONE_DIAL_CODE}${values.executivePhone}`,
    });
    if (!result.error) {
      toast.success(result.message);
      yield put(sendInviteSuccess(true));
      yield call(sendInviteLink, {
        ...values,
        link: `http://20.101.158.40/register/${result.link}`,
      });
    } else if (result.error) {
      toast.error(result.error);
      yield put(sendInviteError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(sendInviteError(message));
    } else {
      toast.error(e.error);
      yield put(sendInviteError(e.error));
    }
  }
}

function* fetchInvitesSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchInvitesRequest());
    const result = yield call(fetchInvites, values);
    if (!result.error) {
      yield put(
        fetchInvitesSuccess({
          data: result.data.data,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      toast.error(result.error);
      yield put(
        fetchInvitesSuccess({
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchInvitesError(message));
    } else {
      toast.error(e.error);
      yield put(fetchInvitesError(e.error));
    }
  }
}

function* rootSagas() {
  yield takeLatest(sagaActions.SEND_INVITE, sendInviteSaga);
  yield takeLatest(sagaActions.FETCH_INVITES, fetchInvitesSaga);
}

export default rootSagas;
